import React from "../../../_snowpack/pkg/react.js";
import {NewCardButtonContainer} from "./styles.js";
const NewCardButton = ({text, getCard, setCard}) => {
  return /* @__PURE__ */ React.createElement(NewCardButtonContainer, {
    type: "button",
    onClick: async () => {
      const cardPayload = await getCard();
      setCard(cardPayload);
    }
  }, text);
};
export default NewCardButton;
